import type { Task } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** Removes one field attachment. 403 when the actor is neither its uploader nor the office. */
export function useRemoveTaskTechnicianAttachment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, attachmentId }: { id: number; attachmentId: number }) =>
      taskApi.removeTechnicianAttachment(id, attachmentId).then((r) => r.data),
    onSuccess: (task) => {
      queryClient.setQueryData(taskKeys.detail(task.id), (prev: Task | undefined) =>
        prev ? { ...prev, technicianAttachments: task.technicianAttachments } : prev,
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
